import { capitalizeFirstLetter } from "../../../../utils/helpers";
import { GetPortalUserAttributeResult } from "../../../../services/api/types/users/users";
import { AttributeValueType } from "../AddNewUser";
import {
  DynamicFieldRenderer,
  FieldConfig,
} from "../../../../components/DynamicFieldRenderer/DynamicFieldRenderer";

type Props = {
  attr: GetPortalUserAttributeResult;
  value: AttributeValueType;
  setValue: (key: string, v: AttributeValueType) => void;
  error?: string;
  disabled?: boolean;
  openFormDatepicker?: boolean;
  onOpenFormDatepicker?: () => void;
  onCloseFormDatepicker?: () => void;
};

export function DynamicAttributeField({
  attr,
  value,
  setValue,
  error,
  disabled = false,
  openFormDatepicker,
  onOpenFormDatepicker,
  onCloseFormDatepicker,
}: Props) {
  const key = attr.attributeKey;
  const label = capitalizeFirstLetter(
    attr["portalUserAttributeTranslations.attributeName"] ||
      attr.attributeName ||
      key,
  );

  const config: FieldConfig = {
    dataType: attr.dataType,
    attributeKey: key,
    attributeName: label,
    isRequired: !!attr.isRequired,
    isLineManager: attr.isLineManager,
  };

  return (
    <DynamicFieldRenderer
      config={config}
      value={value}
      onChange={(newValue) => setValue(key, newValue)}
      error={error}
      disabled={disabled}
      mode="form"
      openFormDatepicker={openFormDatepicker}
      onOpenFormDatepicker={onOpenFormDatepicker}
      onCloseFormDatepicker={onCloseFormDatepicker}
    />
  );
}
